import script from "./LinkUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkUs.vue?vue&type=script&lang=ts&setup=true"

import "./LinkUs.vue?vue&type=style&index=0&id=042f22c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042f22c0"]])

export default __exports__